import React from "react";
import "./App.css";
import MainRoutesComp from "./routes/routes";
import "bootstrap/dist/css/bootstrap.min.css";
import { EventEmitter } from "events";

export const event = new EventEmitter();

function App() {
  React.useEffect(() => {
    const handleLogout = () => {
      localStorage.clear();
      window.location.href = "/";
    };
    event.on("logout", handleLogout);
    return () => {
      event.off("logout", handleLogout);
    };
  }, []);

  return (
    <>
      <MainRoutesComp />
    </>
  );
}

export default App;
